"use strict";
export const DEFAULT_ROUTE_SOURCES = {
  v2: true,
  v3: true,
  zeroX: true,
  openOcean: true
};
export function resolveRouteSources(sources) {
  return { ...DEFAULT_ROUTE_SOURCES, ...sources ?? {} };
}
